import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Title, Meta } from '@angular/platform-browser';
import { AngularFirestore } from '@angular/fire/firestore';
import { AuthService } from 'app/services/auth/auth.service';
import { EmailService } from 'app/services/email/email.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  errorStatus: boolean = false;
  errorMsg : string = '';

  submit:boolean = false;

  encEmail: string;
  encPassword: string;
  encKey: string =  Math.random().toString(36).substring(2, 2) + Math.random().toString(36).substring(2, 8)

  loginForm = this.fb.group({
    email: ['', [Validators.required, Validators.email]],
    password: ['', [Validators.required]],
  })

  title: string = 'Klavea | Login'

  constructor(
    private fb: FormBuilder,
    private router : Router,
    private auth: AuthService,
    private titleService: Title,
    private metaTagService: Meta,
    private afs: AngularFirestore,
    private emailService: EmailService
  ) {
    this.titleService.setTitle(this.title);
    this.metaTagService.updateTag(
      { name: 'description', content: 'Login to your Klavea account' },
    );
    // this.metaTagService.addTags([
    //   { property: 'og:image', content:"https://rise.ng/assets/images/logo2.png" },
    //   { property: 'og:title', content:"Rísé - Home" },
    //   { property: 'og:image', content:"Find and Hire Professional Artisans and Vendors" },
    // ]);
  }

  ngOnInit(): void {
  }

  async login(){
    if(!this.loginForm.valid){
      this.errorStatus = true;
      this.errorMsg = 'Please fill all fields';
      return
    }
    this.errorMsg = '';
    this.submit = true;
    const login = await this.auth.emailSignin(this.loginForm.value);
    if(!login.status){
      this.errorStatus = true;
      this.errorMsg = login.message;
    } else {
      this.auth.authState$.subscribe((user) => {
        console.log(user)
        this.auth.user$.subscribe((data) => {
          console.log(data)
          if (!data.emailVerifiedAt) {
            this.emailService.sendVerificationMail(
              data.displayName,
              data.email,
              data.code
            );
            this.errorStatus = true;
            this.errorMsg =
              "Email not verified. A verification link has been sent to you!";
            this.auth.signOut();
          }
          else if(data?.status && data?.role == 'admin'){
            this.router.navigate([this.auth.redirectLink]);
          }
          else{
            this.errorStatus = true;
            this.errorMsg = 'Access Denied, You are not an administrator';
          }
        })
      })
    }

    this.submit = false;
  }
}
